<div class="flex flex-col items-center carousel-wrapper">
  <ng-content></ng-content>

  <div class="flex flex-row items-center w-100-percent">
    <mat-icon svgIcon="chevron_left" (click)="previous()" class="icon cursor-pointer"
      [ngClass]="{'disabled cursor-default': startIndex === 0, 'hidden': (numDisplayedItems >= items.length)}"></mat-icon>

    <div class="flex flex-row w-100-percent">
      <div *ngFor="let item of items | slice : startIndex : endIndex" class="p-10">
        <ng-container *ngTemplateOutlet="template; context: {$implicit: item}"></ng-container>
      </div>
    </div>

    <mat-icon svgIcon="chevron_right" (click)="next()" class="icon cursor-pointer"
      [ngClass]="{'disabled cursor-default': this.endIndex >= this.items.length, 'hidden': (numDisplayedItems >= items.length)}"></mat-icon>
  </div>

  <div *ngIf="numDisplayedItems < items.length" class="flex flex-row">
    <div *ngFor="let dot of dots; let i = index;"
         class="dot m-4"
         [ngClass]="{'active': i === startIndex / numDisplayedItems}"
         (click)="goTo(i)">
    </div>
  </div>
</div>
